export default function Clients() {
  return (
    <div>
      <h1>Clientes</h1>
    </div>
  );
}
